import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import { SvgHandHeldFill, SvgWelloFill } from '@common/icon';
import Link from 'next/link';
import { POLICY_APPLICATION_TYPE } from '@/api';
import { Image } from '@/components/client';
import { ROUTES } from '@/constants';
export interface ApplyPolicyCardProps {
  isLoading?: boolean;
  idx?: string;
  agencyLogoUrl?: string;
  name?: string;
  applicationType?: POLICY_APPLICATION_TYPE;
}
export const ApplyPolicyCard = t0 => {
  const $ = _c(24);
  const {
    isLoading,
    idx,
    agencyLogoUrl,
    name,
    applicationType
  } = t0;
  let t1;
  bb0: switch (applicationType) {
    case POLICY_APPLICATION_TYPE.JEJU_CONSULTATION:
      {
        t1 = ROUTES.JEJU_REPORT.pathname;
        break bb0;
      }
    case POLICY_APPLICATION_TYPE.SCHOLARSHIP_FOUNDATION:
      {
        t1 = ROUTES.POLICY_REPORT.pathname;
        break bb0;
      }
    default:
      {
        t1 = "#";
      }
  }
  const applyHistoryPath = t1;
  if (isLoading) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Skeleton className="h-200 w-full rounded-large" />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  let t2;
  if ($[1] !== idx) {
    t2 = idx ? ROUTES.POLICY_DETAIL.pathname({
      idIdx: idx
    }) : "#";
    $[1] = idx;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== name || $[4] !== t2) {
    t3 = <Link aria-label={"\uC815\uCC45 \uC0C1\uC138 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"} className="line-clamp-2 font-600 text-Gray-900 typo-body3" href={t2}>{name}</Link>;
    $[3] = name;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = name || "\uC815\uCC45 \uAE30\uAD00 \uB85C\uACE0";
  let t5;
  if ($[6] !== agencyLogoUrl || $[7] !== t4) {
    t5 = <Image alt={t4} className="rounded-large border-1 border-Gray-black/5 object-cover" height={52} src={agencyLogoUrl} width={52} />;
    $[6] = agencyLogoUrl;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <header className="flex items-center justify-between gap-12 px-24 py-20">{t3}{t5}</header>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SvgHandHeldFill className="size-16 text-Gray-400" />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="font-600 text-Gray-600 typo-body4">신청<br />현황보기</p>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== applyHistoryPath) {
    t9 = <Link aria-label={"\uC2E0\uCCAD \uB0B4\uC5ED \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"} className="flex w-66 flex-col items-center gap-8 text-center" href={applyHistoryPath}>{t7}{t8}</Link>;
    $[14] = applyHistoryPath;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="h-38 w-1 bg-Gray-300" />;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <SvgWelloFill originalFill={true} className="size-16 bg-Gray-25 text-Gray-25" />;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Link aria-label={"\uBB38\uC758\uD558\uAE30 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"} className="flex w-66 flex-col items-center gap-8 text-center" href={ROUTES.MY_APPLY_RECOMMEND_INQUIRY.pathname}>{t11}<p className="font-600 text-Gray-600 typo-body4">웰로에게<br />알려주기</p></Link>;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t9) {
    t13 = <div className="flex items-center justify-around bg-Gray-25 px-16 py-20">{t9}{t10}{t12}</div>;
    $[19] = t9;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t13 || $[22] !== t6) {
    t14 = <article className="mb-20 flex flex-col overflow-hidden rounded-large border-1 border-Gray-200">{t6}{t13}</article>;
    $[21] = t13;
    $[22] = t6;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return t14;
};